import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CompanyService } from 'src/app/services/company/company.service';
import { CourseService } from 'src/app/services/course/course.service';
import { DepartmentService } from 'src/app/services/department/department.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { ForumService } from 'src/app/services/forum/forum.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { JobService } from 'src/app/services/job/job.service';
import { PackageService } from 'src/app/services/package/package.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { TimeOffService } from 'src/app/services/time-off/time-off.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-delete-item',
  templateUrl: './delete-item.component.html',
  styleUrls: ['./delete-item.component.scss']
})
export class DeleteItemComponent {
  public userBlock: string = "Block";
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private spinner: NgxSpinnerService, private appService: AppService,
    public dialogRef: MatDialogRef<DeleteItemComponent>, private courseService: CourseService, private forumService: ForumService,
    public userManagementService: UserManagementService, private companyService: CompanyService, private staffSurveyService: StaffSurveyService,
    private packageService: PackageService, private docService: DocumentService, private commonService: CommonService,
    private departmentService: DepartmentService, public recruiter: RecruiterService, private jobService: JobService,private timeClockService:TimeClockService,
    private timeOffService:TimeOffService, private indivisualService : IndividualService
  ) { }

  ngOnInit(): void {
  }
  onDeleteClick() {
    if (this.dialogData["usertype"]) {
      this.onDeleteUser()
    }
    else if (this.dialogData["content_type"] == "delete_course") {
      this.onDeleteCourseAPI(this.dialogData["c_i"])
    }
    else if (this.dialogData["content_type"] == "delete_assign_user") {
      this.onDeleteAssignCourse()
    }
    else if (this.dialogData["content_type"] == "delete_notice") {
      this.onDeleteNotice(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_forum") {
      this.onDeleteForum(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_survey") {
      this.onDeleteSurvey(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_staff_survey_item") {
      this.onDeleteSurveyItem(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_notification") {
      this.onDeleteNotification(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_workflow") {
      this.onDeleteWorkflow(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_package") {
      this.onDeletePackage(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "useful_document") {
      this.onDeleteUsefulDoc(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "action_document") {
      this.onDeletePack(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "course_document") {
      this.onDeleteWorkDoc(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "contract_document") {
      this.onDeleteContractDoc(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_playlist") {
      this.onDeletePlaylist(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_store") {
      this.onDeleteStore(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_m_notification") {
      this.onDeleteMnotification(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_department") {
      this.onDeleteDepartment(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_experience") {
      this.onDeleteExperience(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_bank") {
      this.onDeleteBank(this.dialogData["id"],this.dialogData["em_i"])
    }
    else if (this.dialogData["content_type"] == "delete_profile") {
      this.onDeleteProfile(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_payroll") {
      this.onDeletePayroll(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_notes") {
      this.onDeleteNotes(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_company_category") {
      this.onDeleteCategoryRates(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_dress_code") {
      this.onDeleteDressCode(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_dress_logo") {
      console.log(this.dialogData)
      console.log(this.dialogData["dress_id"])
      this.onDeleteDressLogo(this.dialogData["id"],this.dialogData["dress_id"])
    }
    else if (this.dialogData["content_type"] == "delete_company_subcategory") {
      this.onDeleteSubCategoryRates(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_shift") {
      this.onDeleteShift(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_shift_template") {
      this.onDeleteTempShift(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_address") {
      this.onDeleteAddress(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == "delete_clock_card") {
      this.onDeleteClockCard(this.dialogData["id"])
    }
    else if(this.dialogData["content_type"] == "delete_timeoff"){
      this.onDeleteTimeOff(this.dialogData["id"]);
    }
    else if (this.dialogData["content_type"] == "delete_event") {
      this.onDeleteEvent(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == 'delete_task') {
      this.onDeleteTask(this.dialogData["id"])
    }
    else if (this.dialogData["content_type"] == 'delete_conflict') {
      this.onDeleteConflict(this.dialogData)
    }
    else {
      this.dialogRef.close({ delete_content: true });
    }
  }
  onDeleteUser() {
    this.spinner.show()
    let email_value = ""
    if (this.dialogData["email"]) {
      email_value = this.dialogData["email"]
    }
    this.userManagementService.deleteUser(this.dialogData["usertype"], this.dialogData["id"], email_value).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.spinner.hide()
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close({ user_type: this.dialogData["usertype"] });
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error)
      }
    })
  }
  onCancel() {
    this.dialogRef.close()
  }
  onUserBlockUnblock() {
    this.spinner.show()
    let email_value = ""
    if (this.dialogData["email"]) {
      email_value = this.dialogData["email"]
    }
    this.userManagementService.deleteUser(this.dialogData["usertype"], this.dialogData["id"], email_value).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.spinner.hide()
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close(true);
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteCourseAPI(c_i: any) {
    let obj: {} = {
      "c_i": c_i,
      t: this.dialogData["t"]
    }
    this.spinner.show();
    this.courseService.deleteCourse(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteNotification(id: any) {
    let obj = {
      "id": id,
    }
    this.spinner.show();
    this.indivisualService.hideNotification(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteAssignCourse() {
    let obj: {} = {
      a_ci: this.dialogData["dataObj"]["a_ci"],
      t: this.dialogData["dataObj"]["t"]
    }
    this.spinner.show();
    this.userManagementService.assignCourseDelete(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteConflict(data) {
    let obj: {} = {
      em_i: this.dialogData.em_i,
      wo_ti_id: this.dialogData.wo_ti_id,
      id:this.dialogData.id
    }
    this.spinner.show();
    this.recruiter.deleteConflictInsight(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteNotice(id) {
    this.spinner.show();
    this.companyService.noticeDelete(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteForum(id) {
    this.spinner.show();
    this.forumService.delete(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteSurveyItem(id) {
    this.dialogRef.close({ delete_content: true });
  }
  onDeleteSurvey(id) {
    this.spinner.show();
    this.staffSurveyService.delete(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteWorkflow(id) {
    let obj = {
      'wu_i': id,
    }
    this.spinner.show();
    this.recruiter.deleteWorkflow(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeletePackage(id) {
    let data = {
      "pc_i": id
    }
    this.spinner.show();
    this.packageService.deletePackage(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteUsefulDoc(id) {
    this.spinner.show();
    this.docService.deleteUsefulDocument(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteWorkDoc(id) {
    this.spinner.show();
    this.docService.deleteCourseWorkDoc(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteContractDoc(id) {
    this.spinner.show();
    let data = {
      doc_id: id
    }
    this.docService.deleteContractDoc(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeletePack(id) {
    this.spinner.show();
    let data: Object = {
      "pack_id": id
    }
    this.docService.deletePack(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onPubUnpubPackage() {
    let pub = 1;
    if (this.dialogData["pub"] == 1) {
      pub = 0
    }
    let data = {
      'pc_i': this.dialogData["id"],
      'pub': pub
    }
    this.spinner.show();
    this.packageService.pubUnpubPackage(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ publish_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeletePlaylist(id) {
    let data = {
      'pl_id': id,
    }
    this.spinner.show();
    this.courseService.deletePlaylist(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteStore(id) {
    let data = {
      'id': id,
    }
    this.spinner.show();
    this.courseService.deleteStore(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteMnotification(id) {

    let data = {
      'common_id': id,
    }
    this.spinner.show();
    this.recruiter.deleteMNotification(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteDepartment(id) {
    let data = {
      'company_department_id': id,
    }
    this.spinner.show();
    this.departmentService.delete(id).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteExperience(id) {
    let data = {
      'experience_id': id,
    }
    this.spinner.show();
    this.recruiter.deleteExp(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteBank(id,em_i) {
    let data = {
      'bank_id': id,
      'em_i': em_i,
    }
    this.spinner.show();
    this.recruiter.deleteBank(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteProfile(id) {
    let data = {
      'profile_id': id,
    }
    this.spinner.show();
    this.recruiter.deleteProfile(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeletePayroll(id) {
    let data = {
      'profile_id': id,
    }
    this.spinner.show();
    this.recruiter.deleteProfile(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteNotes(id) {
    let data = {
      'em_i': this.dialogData['em_i'],
      'no_id': id,
    }
    this.spinner.show();
    this.recruiter.deleteNotes(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteCategoryRates(id) {
    let data = {
      "w_t": this.dialogData["wages_type"],
      "jc_id": id,
      "em_i": "",
      "co_i": ""
    }
    this.spinner.show();
    this.recruiter.deleteCategory(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteDressCode(id) {
    let data = {
      "dress_id": id,
    }
    this.spinner.show();
    this.recruiter.deleteDressCode(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteDressLogo(id,dress_id) {
    let data = {
      "dress_id": dress_id,
      "logo_id": id,
    }
    this.spinner.show();
    this.recruiter.deleteDressLogo(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteSubCategoryRates(id) {
    let data = {
      "w_t": this.dialogData["wages_type"],
      "j_sc_id": id,
      "em_i": this.dialogData["em_i"],
      "co_i": ""
    }
    this.spinner.show();
    this.recruiter.deleteSubCategory(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteShift(id) {
    let data = {
      "st_dt": "",
      "ed_dt": "",
      "del_t": "0",// 0= this shift 1= future shift 2=all this series.
      "sh_id": id,
      "comm_id": this.dialogData['comm_id'],
    }
    this.spinner.show();
    this.jobService.deleteShift(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      }
    })
  }
  onDeleteTempShift(id) {
    let data = {
      "comm_id": this.dialogData['id'],
    }
    this.spinner.show();
    this.jobService.deleteTemplate(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      }
    })
  }
  onClearSchedule() {

  }
  onDeleteAddress(id) {
    let data = {
      "add_id": this.dialogData.add_i,
      "co_i": "id" // if user is recruiter
    }
    this.spinner.show();
    this.jobService.deleteAddress(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      }
    })
  }
  onDeleteClockCard(id){
    let data = {
      "tc_id": this.dialogData.id,
    }
    this.spinner.show();
    this.timeClockService.deleteCard(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      }
    })
  }
  onDeleteTimeOff(id){
    let data = {
      "po_id": this.dialogData.id,
    }
    if (this.dialogData.company_id) {
      data["company_id"] = this.dialogData.company_id;
    }
    this.spinner.show();
    this.timeOffService.deletePolicy(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      }
    })
  }
  onDeleteEvent(id) {
    let data = {
      'id': id,
    }
    this.spinner.show();
    this.recruiter.deleteEvent(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
  onDeleteTask(id) {
    let data = {
      'id': id,
    }
    this.spinner.show();
    this.recruiter.deleteTask(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ delete_content: true });
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error)
      }
    })
  }
}